import { EStreamSourceType } from '../../domain/live-feed';
import { LiveSourceStatus } from '../../domain/live-sources';

/**
 * Status visual metadata — label and CSS class for semantic colors.
 * Colors are set in SCSS from _theme.scss.
 */
export interface SourceStatusMeta {
  label: string;
  cssClass: string;
}

export const SOURCE_STATUS_META: Record<LiveSourceStatus, SourceStatusMeta> = {
  [LiveSourceStatus.Active]:  { label: 'Live',        cssClass: 'status--active' },
  [LiveSourceStatus.Paused]:  { label: 'Inactive',    cssClass: 'status--paused' },
  [LiveSourceStatus.Error]:   { label: 'Error',       cssClass: 'status--error' },
  [LiveSourceStatus.Idle]:    { label: 'Connecting',  cssClass: 'status--idle' },
};

export const DEFAULT_SOURCE_STATUS_META: SourceStatusMeta = {
  label: 'Unknown',
  cssClass: 'status--unknown',
};

/** Protocol filter options for the toolbar dropdown. */
export const LIVE_SOURCE_PROTOCOL_OPTIONS: { value: EStreamSourceType; label: string }[] = [
  { value: EStreamSourceType.SRT_PULL, label: 'SRT' },
  { value: EStreamSourceType.RTMP_PUSH, label: 'RTMP' },
  { value: EStreamSourceType.HLS_PULL, label: 'HLS' },
  { value: EStreamSourceType.RTSP_PULL, label: 'RTSP' },
  { value: EStreamSourceType.DASH_PULL, label: 'DASH' },
  { value: EStreamSourceType.ZIXI_PUSH, label: 'ZIXI' },
  { value: EStreamSourceType.TCP_PULL, label: 'TCP' },
];
